import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { NgToastService } from 'ng-angular-popup';
import { EvaluationCriteriaWrapperComponent } from '../evaluation-criteria-wrapper.component';
import { MatDialog } from '@angular/material/dialog';
import { ScoreService } from '../../scores.service';

@Component({
  selector: 'app-commercial-evaluation-criteria',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    ReactiveFormsModule,
  ],
  templateUrl: './commercial-evaluation-criteria.component.html',
  styleUrl: './commercial-evaluation-criteria.component.css',
})
export class CommercialEvaluationCriteriaComponent implements OnInit {
  @Input() data: any;
  calculatedResult: number;

  constructor(
    private tenderingService: TenderingService,
    private toast: NgToastService,
    private evaluationCriteriaWrapper: EvaluationCriteriaWrapperComponent,
    public dialog: MatDialog,
    private scoreService: ScoreService,
  ) {}
  ngOnInit(): void {
    this.getCommercialEvaluationResponse();
  }

  priceCompetitivenessControl = new FormControl('');
  paymentTermsControl = new FormControl('');
  financialStabilityControl = new FormControl('');
  commercialRiskAllocationControl = new FormControl('');


  keyIndicators = {
    0: { name: 'Non-compliant', value: 0, description: 'No evidence provided, or response does not meet the requirements.' },
    1: { name: 'Poor', value: 1, description: 'Limited evidence, significant omissions, or lack of understanding of the requirements.' },
    2: { name: 'Satisfactory', value: 2, description: 'Meets minimum requirements but lacks sufficient detail or innovation.' },
    3: { name: 'Good', value: 3, description: 'Meets requirements with clear understanding, detailed response, and some value-added propositions.' },
    4: { name: 'Very Good', value: 4, description: 'Exceeds requirements with strong evidence, innovative solutions, and added benefits for the project.' },
    5: { name: 'Excellent', value: 5, description: 'Far exceeds requirements with outstanding evidence, significant innovation, and measurable added value.' },
  };

  evaluationCriteriaOptions: { name: string; value: number, description: string }[] = [
    { name: 'Non-compliant', value: 0, description: 'No evidence provided, or response does not meet the requirements.' },
    { name: 'Poor', value: 1, description: 'Limited evidence, significant omissions, or lack of understanding of the requirements.' },
    { name: 'Satisfactory', value: 2, description: 'Meets minimum requirements but lacks sufficient detail or innovation.' },
    { name: 'Good', value: 3, description: 'Meets requirements with clear understanding, detailed response, and some value-added propositions.' },
    { name: 'Very Good', value: 4, description: 'Exceeds requirements with strong evidence, innovative solutions, and added benefits for the project.' },
    { name: 'Excellent', value: 5, description: 'Far exceeds requirements with outstanding evidence, significant innovation, and measurable added value.' },
  ];

  commercialEvaluationCriteria = [
    {
      criteria: 'Price Competitiveness',
      score: '',
      comments: 'All requirements met without issues',
      controlName: this.priceCompetitivenessControl,
      iconClass: `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='27' height='27' viewBox='0 0 27 27' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M3.46591 8.69857C2.85003 9.62147 2.40669 10.6693 2.1821 11.7961H0.807996C0.624375 11.7961 0.474609 11.9458 0.474609 12.1295V14.8659C0.474609 15.0495 0.624375 15.1993 0.807996 15.1993H2.1821C2.40285 16.306 2.83907 17.3585 3.46591 18.2969L2.49376 19.269C2.36392 19.3988 2.36392 19.6107 2.49376 19.7406L4.42863 21.6755C4.55847 21.8054 4.7703 21.8054 4.90018 21.6755L5.87239 20.7033C6.8108 21.3302 7.86328 21.7664 8.96996 21.9872V23.3612C8.96996 23.5448 9.11972 23.6946 9.30335 23.6946H10.6609C10.6589 23.6621 10.6579 23.6295 10.6579 23.5969V19.7404C7.21633 19.733 4.42869 16.941 4.42869 13.4977C4.42869 10.0544 7.21633 7.2624 10.6579 7.25501V3.39855C10.6579 3.3657 10.659 3.33311 10.6609 3.30078H9.30335C9.11972 3.30078 8.96996 3.45055 8.96996 3.63417V5.00837C7.8633 5.22915 6.81083 5.66534 5.87245 6.29214L4.90024 5.31993C4.7704 5.1901 4.55857 5.1901 4.42869 5.31993L2.49376 7.25486C2.36392 7.38469 2.36392 7.59652 2.49376 7.72636L3.46591 8.69857Z' fill='%23E76B3F'/><path fill-rule='evenodd' clip-rule='evenodd' d='M26.5257 5.39377L23.7609 2.62891V4.62327C23.7609 5.04757 24.1071 5.39377 24.5314 5.39377H26.5257ZM11.502 23.5977V3.39941C11.502 2.97516 11.8481 2.62891 12.2725 2.62891H22.9172V4.62327C22.9172 5.51321 23.6415 6.23752 24.5314 6.23752H26.5257V23.5977C26.5257 24.0221 26.1795 24.3682 25.7552 24.3682H12.2725C11.8482 24.3682 11.502 24.022 11.502 23.5977ZM14.2406 7.22075H23.7871C23.8989 7.22075 24.0063 7.1763 24.0854 7.09719C24.1645 7.01807 24.2089 6.91077 24.2089 6.79888C24.2089 6.68699 24.1645 6.57968 24.0854 6.50057C24.0063 6.42145 23.8989 6.377 23.7871 6.377H14.2406C14.1287 6.377 14.0214 6.42145 13.9422 6.50057C13.8631 6.57968 13.8187 6.68699 13.8187 6.79888C13.8187 6.91077 13.8631 7.01807 13.9422 7.09719C14.0214 7.1763 14.1287 7.22075 14.2406 7.22075ZM14.2406 20.6201H23.7871C23.8989 20.6201 24.0063 20.5757 24.0854 20.4966C24.1645 20.4175 24.2089 20.3101 24.2089 20.1983C24.2089 20.0864 24.1645 19.9791 24.0854 19.9C24.0063 19.8208 23.8989 19.7764 23.7871 19.7764H14.2406C14.1287 19.7764 14.0214 19.8208 13.9422 19.9C13.8631 19.9791 13.8187 20.0864 13.8187 20.1983C13.8187 20.3101 13.8631 20.4175 13.9422 20.4966C14.0214 20.5757 14.1287 20.6201 14.2406 20.6201ZM14.2406 17.2703H23.7871C23.8989 17.2703 24.0063 17.2258 24.0854 17.1467C24.1645 17.0676 24.2089 16.9603 24.2089 16.8484C24.2089 16.7365 24.1645 16.6292 24.0854 16.5501C24.0063 16.471 23.8989 16.4265 23.7871 16.4265H14.2406C14.1287 16.4265 14.0214 16.471 13.9422 16.5501C13.8631 16.6292 13.8187 16.7365 13.8187 16.8484C13.8187 16.9603 13.8631 17.0676 13.9422 17.1467C14.0214 17.2258 14.1287 17.2703 14.2406 17.2703ZM14.2406 13.9204H23.7871C23.8989 13.9204 24.0063 13.876 24.0854 13.7969C24.1645 13.7178 24.2089 13.6105 24.2089 13.4986C24.2089 13.3867 24.1645 13.2794 24.0854 13.2003C24.0063 13.1211 23.8989 13.0767 23.7871 13.0767H14.2406C14.1287 13.0767 14.0214 13.1211 13.9422 13.2003C13.8631 13.2794 13.8187 13.3867 13.8187 13.4986C13.8187 13.6105 13.8631 13.7178 13.9422 13.7969C14.0214 13.876 14.1287 13.9204 14.2406 13.9204ZM14.2406 10.5706H23.7871C23.8989 10.5706 24.0063 10.5262 24.0854 10.447C24.1645 10.3679 24.2089 10.2606 24.2089 10.1487C24.2089 10.0368 24.1645 9.92953 24.0854 9.85041C24.0063 9.7713 23.8989 9.72685 23.7871 9.72685H14.2406C14.1287 9.72685 14.0214 9.7713 13.9422 9.85041C13.8631 9.92953 13.8187 10.0368 13.8187 10.1487C13.8187 10.2606 13.8631 10.3679 13.9422 10.447C14.0214 10.5262 14.1287 10.5706 14.2406 10.5706Z' fill='%23EA4A12'/></svg>`,
    },
    {
      criteria: 'Payment Terms',
      score: '',
      comments: 'Sufficient methodology, minor improvements needed',
      controlName: this.paymentTermsControl,
      iconClass: `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='26' height='23' viewBox='0 0 26 23' fill='none'><path fill-rule='evenodd' clip-rule='evenodd' d='M8.92234 3.89565C8.82014 3.46607 8.64986 3.05575 8.4183 2.67975L8.76904 1.89011L7.83807 0.959186L7.04816 1.30997C6.67227 1.07852 6.26205 0.908244 5.83258 0.806045L5.52234 0H4.20583L3.89554 0.806045C3.46607 0.908244 3.0559 1.07852 2.67996 1.30997L1.89005 0.959186L0.959185 1.89016L1.30997 2.67996C1.07847 3.05585 0.908191 3.46613 0.805992 3.89559L0 4.20583V5.5224L0.805887 5.83258C0.908086 6.26215 1.07837 6.67248 1.30992 7.04848L0.959238 7.83812L1.89021 8.76904L2.68012 8.41825C3.05601 8.6497 3.46618 8.81998 3.8957 8.92218L4.20594 9.72823H5.5225L5.83269 8.92234C6.26226 8.82014 6.67259 8.64986 7.04858 8.41831L7.83823 8.76904L8.76915 7.83807L8.41836 7.04816C8.64981 6.67227 8.82009 6.2621 8.92229 5.83263L9.72833 5.5224V4.20583L8.92234 3.89565ZM4.86406 7.16017C3.5959 7.16017 2.56801 6.13232 2.56801 4.86417C2.56801 3.59596 3.5959 2.56811 4.86406 2.56811C6.13227 2.56811 7.16011 3.59596 7.16011 4.86417C7.16017 6.13232 6.13227 7.16017 4.86406 7.16017ZM13.486 18.2923C13.9837 18.4937 14.39 18.432 14.6746 17.954C14.9132 17.5531 14.7147 17.0369 14.3496 16.7859C13.0858 16.187 11.922 15.3759 11.0071 14.7382C9.68261 13.815 9.33783 13.5884 7.66484 14.0389L4.62997 14.8561L5.7731 19.2736L6.02601 19.2059C6.14962 19.1728 6.27502 19.1984 6.37295 19.2653L11.7413 22.3638C12.4137 22.7521 13.1334 22.8491 13.8796 22.6264L23.216 19.839C23.5179 19.7489 23.7439 19.4163 23.8027 19.0489C23.8507 18.7481 23.7758 18.4366 23.5436 18.2285C23.1782 17.901 22.4304 17.7672 21.1278 18.1215L16.0225 19.5104C15.6183 19.6203 15.222 19.6532 14.8279 19.6154C13.6824 19.5059 12.1822 19.5499 11.2804 18.0094C10.9814 17.8301 10.6778 17.6481 10.404 17.49C10.2028 17.3744 10.1335 17.1177 10.249 16.9166C10.3646 16.7154 10.6214 16.6461 10.8225 16.7616C11.7085 17.273 12.5722 17.8329 13.486 18.2923ZM5.35676 21.0326L3.51459 13.9135C3.42552 13.5693 3.07099 13.3605 2.72679 13.4496L1.35633 13.8042C1.01213 13.8932 0.803356 14.2478 0.892424 14.592L2.73459 21.7111C2.82366 22.0553 3.17814 22.264 3.52239 22.175L4.89285 21.8203C5.23705 21.7313 5.44583 21.3768 5.35676 21.0326ZM2.84977 15.1132C2.8215 15.3545 2.60302 15.5272 2.36171 15.4989C2.12045 15.4706 1.9478 15.2522 1.97606 15.0108C2.00433 14.7696 2.22281 14.5969 2.46412 14.6251C2.70533 14.6535 2.87798 14.8719 2.84977 15.1132ZM24.0554 6.51813C23.896 5.84798 23.6303 5.20789 23.2691 4.62138L23.8162 3.38955L22.364 1.93736L21.1318 2.48463C20.5454 2.12356 19.9055 1.85794 19.2355 1.69852L18.7516 0.441123H16.6978L16.2138 1.69852C15.5438 1.85794 14.9039 2.12356 14.3175 2.48463L13.0853 1.93741L11.6332 3.38966L12.1804 4.62169C11.8193 5.2081 11.5536 5.84803 11.3942 6.51807L10.1369 7.00202V9.05576L11.394 9.53965C11.5535 10.2097 11.819 10.8499 12.1803 11.4363L11.6332 12.6682L13.0855 14.1204L14.3176 13.5732C14.9041 13.9343 15.5439 14.1998 16.2139 14.3593L16.6979 15.6167H18.7516L19.2355 14.3596C19.9056 14.2002 20.5457 13.9345 21.1322 13.5733L22.364 14.1204L23.8162 12.6682L23.269 11.436C23.6301 10.8496 23.8956 10.2097 24.0551 9.53975L25.3125 9.05576V7.00197L24.0554 6.51813ZM17.7247 12.3721C15.3261 12.3721 13.3816 10.4275 13.3816 8.02891C13.3816 5.63034 15.3261 3.68576 17.7247 3.68576C20.1233 3.68576 22.0679 5.63034 22.0679 8.02891C22.0679 10.4275 20.1233 12.3721 17.7247 12.3721ZM17.7247 4.52951C15.792 4.52951 14.2253 6.09615 14.2253 8.02891C14.2253 8.91875 14.5574 9.73097 15.1044 10.3484C15.4457 9.22482 16.4896 8.40707 17.7247 8.40707C18.9598 8.40707 20.0038 9.22482 20.345 10.3484C20.892 9.73097 21.2241 8.91875 21.2241 8.02891C21.2241 6.09615 19.6575 4.52951 17.7247 4.52951ZM17.7248 7.97022C16.9601 7.97022 16.3403 7.35038 16.3403 6.58573C16.3403 5.82108 16.9601 5.20124 17.7248 5.20124C18.4894 5.20124 19.1093 5.82108 19.1093 6.58573C19.1093 7.35038 18.4894 7.97022 17.7248 7.97022Z' fill='%23F4551D'/></svg>`,
    },
    {
      criteria: 'Financial Stability',
      score: '',
      comments: 'Adequate plan, needs refinement',
      controlName: this.financialStabilityControl,
      iconClass: 'assets/images/teamworks.jpg',
    },
    {
      criteria: 'Commercial Risk Allocation',
      score: '',
      comments: 'Relevant experience, more examples suggested',
      controlName: this.commercialRiskAllocationControl,
      iconClass: `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='27' height='27' viewBox='0 0 24 24' fill='none'><path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17.93c-4.26-.48-7.62-4.06-7.62-8.43 0-.7.09-1.37.24-2.02L12 12v6h.93c-.15.64-.41 1.25-.93 1.93zM12 4c1.63 0 3.15.49 4.42 1.31L11 10.17V4h1z' fill='%23E76B3F'/></svg>`,
    },
  ];

  getCommercialEvaluationResponse() {
    this.tenderingService
      .getIttCommercialResult(this.data?.ittId, this.data?.responseId)
      .subscribe({
        next: (response) => {
          const data = response.data;
          Object.keys(data).forEach((k) => {
            const obj = this.commercialEvaluationCriteria.find(
              (ec) => ec.criteria === k
            );
            if (obj) {
              obj.score = data[k];
              obj.controlName.setValue(obj.score);
            }
          });
          this.calculatedResult = response?.data?.Score
            ? response?.data?.Score
            : 0;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  
  changeValue(item: any, eventValue){    
    item.score = eventValue.value;
    item.controlName.setValue(eventValue.value);    
  }

  prepareDataToSubmit(status: string) {
    const values: any = {
      'Price Competitiveness': this.priceCompetitivenessControl.value,
      'Payment Terms': this.paymentTermsControl.value,
      'Financial Stability': this.financialStabilityControl.value,
      'Commercial Risk Allocation': this.commercialRiskAllocationControl.value,
    };

    if (status === 'submission') {
      values['Score'] = this.calculatedResult; // Add the Score property dynamically
    }

    const data = { values };
    return data;
  }

  calculateResult() {
    const data = this.prepareDataToSubmit('calculation');
    this.tenderingService
      .calculateCommercialResult(data, this.data?.ittId, this.data?.responseId)
      .subscribe({
        next: (response) => {
          if (response) {
            this.calculatedResult = response?.data?.score;
            this.scoreService.updateScore(this.data?.applicantOrgId, this.calculatedResult, 'comm'); 
          }
        },
        error: (error) => {
          if (error) console.log(error);
        },
      });
  }

  submitForm() {
    const data = this.prepareDataToSubmit('submission');
    this.tenderingService
      .submitCommercialResult(data, this.data?.ittId, this.data?.responseId)
      .subscribe({
        next: (response) => {
          if (response)
            this.toast.success(
              'Commercial evaluation saved successfully',
              'SUCCESS',
              2000
            );
            this.dialog.closeAll();
        },
        error: (error) => {
          this.toast.danger(error, 'ERROR', 4000);
        },
      });
  }

  handleBack() {
     this.evaluationCriteriaWrapper.previousStep();
  }

}
